/**
 * When the dustbag acknowledgement applies, as a predicate the two
 * drawers can both ask.
 *
 * Its own module rather than an export beside the component, so
 * `DustbagConfirmAction.tsx` exports a component and nothing else --
 * see `design-system/components/dialog-styles.ts` for the same split
 * and the same reason.
 */
/** The v1 `TaskCategory` this control belongs to. Compared against
 *  `TaskStateView.type`, which IS the v1 category (`adaptTaskSummary`
 *  maps `TaskSummary.category` straight onto it) and not RMF's own
 *  task type. */
export const DUSTBAG_CATEGORY = 'dustbag';

/** A dustbag task still capable of waiting for an ack. A terminal
 *  record cannot be confirmed — the wait is over either way — and
 *  offering the button there would invite a press that 409s. */
export function isConfirmableDustbagTask(
  task: { type: string; status: string } | null | undefined,
): boolean {
  if (!task || task.type !== DUSTBAG_CATEGORY) return false;
  return task.status === 'active' || task.status === 'queued' || task.status === 'interrupted';
}
